import { DateUtils } from '@atlassian/mpac-utils';
import { addDays } from 'date-fns';
import { Option } from 'funfix-core';
import capitalize from 'lodash/capitalize';
import findBetweenTiers from './findBetweenTiers';
import { foldSubscriptionPeriod } from './types/SubscriptionPeriod';
export const DEFAULT_CURRENCY_CODE = 'USD';
const USD_LOCALE = 'en-us';
export const formatPrice = function formatPrice(amount, currencyCode) {
  let minimumFractionDigits = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  const currencyDisplayFormat = currencyCode === 'USD' ? 'code' : 'symbol';
  return amount.toLocaleString(USD_LOCALE, {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits,
    currencyDisplay: currencyDisplayFormat,
    maximumFractionDigits: 2
  });
};
export const getSubscriptionText = (appPricing, currentUsers, estimate, subscriptionPeriod, appSupportsEdition, standardEditionPrice, selectedEditionPrice, selectedEditionType) => {
  const userRange = findBetweenTiers(appPricing, currentUsers).fold(error => {
    console.error('Error when resolving app pricing tiers', error);
    return '';
  }, tiers => {
    const lowerBound = tiers.lower.map(t => t.unitCount + 1).getOrElse(1);
    const upperBound = Option.some(tiers.upper.unitCount).filter(u => u !== Number.POSITIVE_INFINITY);
    const editionText = appSupportsEdition ? "\"".concat(capitalize(selectedEditionType || 'STANDARD'), " Plan\"") : '';
    return " ".concat(editionText, " of ").concat(lowerBound.toString()).concat(upperBound.map(ub => "-".concat(ub)).getOrElse('+'), " users");
  });

  // Licensed users can be 0 when the
  // instance is under evaluation
  if (currentUsers) {
    const edition = selectedEditionPrice ? selectedEditionPrice : standardEditionPrice;
    const amount = appSupportsEdition && edition ? edition.amount : estimate.amount;
    const formattedPrice = formatPrice(amount / currentUsers, estimate.currencyCode);
    return foldSubscriptionPeriod(subscriptionPeriod, () => "monthly".concat(appSupportsEdition ? '' : ' plan').concat(userRange, " at ").concat(formattedPrice, " per user/month"), () => "annual".concat(appSupportsEdition ? '' : ' plan').concat(userRange, " at ").concat(formattedPrice, " per user/year"));
  } else {
    return foldSubscriptionPeriod(subscriptionPeriod, () => "monthly".concat(appSupportsEdition ? '' : ' plan').concat(userRange), () => "annual".concat(appSupportsEdition ? '' : ' plan').concat(userRange));
  }
};
export const makePricingExplanationForUninstalled = (appPricing, currentUsers, estimate, subscriptionPeriod, cloudMigrationTrial, appSupportsEdition, standardEditionPrice, selectedEditionPrice, selectedEditionType) => {
  const subscriptionText = getSubscriptionText(appPricing, currentUsers, estimate, subscriptionPeriod, appSupportsEdition, standardEditionPrice, selectedEditionPrice, selectedEditionType);
  if (cloudMigrationTrial !== null && cloudMigrationTrial !== void 0 && cloudMigrationTrial.isEligible && cloudMigrationTrial !== null && cloudMigrationTrial !== void 0 && cloudMigrationTrial.btfSenEndDate) {
    const expiry = DateUtils.formatDateObject(cloudMigrationTrial.btfSenEndDate, 'MMM dd, yyyy');
    return "If you proceed, your Cloud Migration Trial starts today and will end on ".concat(expiry, ". ") + "Post which, this estimate will be valid, which is customized for your ".concat(subscriptionText, ".");
  } else {
    const expiry = DateUtils.formatDateObject(addDays(Date.now(), 30), 'MMM dd, yyyy');
    return "If you proceed, your free trial starts today and will end on ".concat(expiry, ".\n    This estimate is customized for your ").concat(subscriptionText, ".");
  }
};
export const makePricingExplanationForEvaluation = (appPricing, currentUsers, estimate, subscriptionPeriod, trialEndDate, appSupportsEdition, standardEditionPrice, selectedEditionPrice, selectedEditionType) => {
  const subscriptionText = getSubscriptionText(appPricing, currentUsers, estimate, subscriptionPeriod, appSupportsEdition, standardEditionPrice, selectedEditionPrice, selectedEditionType);
  return "This estimate is customized for your ".concat(subscriptionText, ". Your free trial will end on ").concat(trialEndDate, ".");
};
export const makePricingExplanationForSubscription = (appPricing, currentUsers, estimate, subscriptionPeriod, appSupportsEdition, standardEditionPrice, selectedEditionPrice, selectedEditionType) => {
  const subscriptionText = getSubscriptionText(appPricing, currentUsers, estimate, subscriptionPeriod, appSupportsEdition, standardEditionPrice, selectedEditionPrice, selectedEditionType);
  return "This estimate is customized for your ".concat(subscriptionText);
};